//全局搜索热门搜索历史接口
import states from '../state/pageHistory';
import mutations from '../mutations/pageHistory';
import actions from '../actions/pageHistory';
import getters from '../getters/pageHistory';

export default {
    namespaced: true,
    states,
    mutations,
    actions,
    getters
};
